<template>
  <video
    v-show          = "visible"
    class           = "video-main"
    ref             = "mainVideo"
    @durationchange = "setDuration($event.target.duration)"
    @timeupdate     = "changeCurrentTime($event.target.currentTime)"
  />
</template>

<script lang="">
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {}
  },
  props    : [],
  computed : { ...mapGetters('video', ['visible']) },
  methods  : {
    // setStream () {
    //   this.$getPeerRoom(this.$route.params.id).replaceStream(this.$refs.mainVideo.captureStream())
    // },
    changeVideoSource (element) {
      this.$refs.mainVideo.src = element.src
    },
    ...mapMutations('video', [
      'setDuration',
      'changeCurrentTime',
      'setPlayer'
    ])
  },
  mounted () {
    this.setPlayer(this.$refs.mainVideo)
    this.$eventHub.$on('changeMainVideo', this.changeVideoSource)
  }
}
</script>

<style scoped>
.video-main {
  position : absolute;
  top      : 0;
  left     : 0;
  width    : 1920px;
  height   : 1080px;
}
</style>



// WEBPACK FOOTER //
// src/components/video/content/video-file.vue